// service/Agenda.js
//
// Cliente del módulo Agendamiento del panel (servicios con hora: quiropraxia,
// masajes…). La compra la hace el público desde el sitio informativo; acá se
// administra. Endpoints: /agenda/admin/* (permiso `agenda` del rol).
//
// La instancia axios ya devuelve el cuerpo de la respuesta (libs/axios.js). Los
// errores se relanzan tal cual: los componentes leen el mensaje con
// `mensajeDeError` y, en el bloqueo con reservas, la lista en `response.data.citas`.

import instance from '../apis/app';

const BASE = '/agenda/admin';

const Agenda = {
  // Servicios
  servicios: async () => (await instance.get(`${BASE}/servicios`)).servicios,
  crearServicio: async (d) => (await instance.post(`${BASE}/servicios`, d)).servicio,
  actualizarServicio: async (id, d) => (await instance.put(`${BASE}/servicios/${id}`, d)).servicio,

  // Agendas (profesionales / boxes). Crear y actualizar devuelven
  // { agenda, advertencias }: reservas futuras que quedaron fuera del nuevo horario.
  agendas: async () => (await instance.get(`${BASE}/agendas`)).agendas,
  crearAgenda: (d) => instance.post(`${BASE}/agendas`, d),
  actualizarAgenda: (id, d) => instance.put(`${BASE}/agendas/${id}`, d),
  agregarBloqueo: (id, d) => instance.post(`${BASE}/agendas/${id}/bloqueos`, d),
  quitarBloqueo: async (id, bloqueoId) => (await instance.delete(`${BASE}/agendas/${id}/bloqueos/${bloqueoId}`)).agenda,

  // Horas libres de un servicio (sin las reglas de anticipación del sitio público)
  disponibilidad: ({ servicio, desde, hasta, agenda }) =>
    instance.get(`${BASE}/disponibilidad`, { params: { servicio, desde, hasta, agenda } }),

  // Reservas
  citas: async (params) => (await instance.get(`${BASE}/citas`, { params })).citas,
  cita: async (id) => (await instance.get(`${BASE}/citas/${id}`)).cita,
  reprogramar: async (id, { agendaId, inicio }) => (await instance.post(`${BASE}/citas/${id}/reprogramar`, { agendaId, inicio })).cita,
  cancelar: async (id, d) => (await instance.post(`${BASE}/citas/${id}/cancelar`, d)).cita,
  asistencia: async (id, asistencia) => (await instance.post(`${BASE}/citas/${id}/asistencia`, { asistencia })).cita,
  reenviarCorreo: (id) => instance.post(`${BASE}/citas/${id}/reenviar-correo`),
  resolverBoleta: async (id, d) => (await instance.post(`${BASE}/citas/${id}/boleta/resolver`, d)).cita,
  reconciliarPagos: async () => (await instance.post(`${BASE}/citas/reconciliar-pagos`)).resultado,

  // Ventas por día y medio de pago: { desde, hasta, filas, total }
  ventas: ({ desde, hasta }) => instance.get(`${BASE}/ventas`, { params: { desde, hasta } }),
};

export default Agenda;
